<template>
  <div id="footer">
    <div class="footer border-box">
      <div class="footer-con clearfix">
        <div class="fl footer-logo">
          <img src="../assets/img/logo.png" alt="新希望乳业">
        </div>
        <ul class="fl footer-list" v-for="(item,index) in navList" :key="index" :data-ind="index" v-if="index!==0">
          <li class="item item-head" @click="navClick(index,item.name)"><router-link :to="item.path" :class="index==navIndex?'router-link-active':''">{{item.name}}</router-link></li>
          <li class="item" v-for="(i,n) in item.children" :key="n" @click="navClick(index,item.name)" v-if="item.children.length>0">
            <a :href="i.path" target="_blank" v-if="i.isOutlink">{{i.name}}</a>
            <router-link :to="i.path" v-else>{{i.name}}</router-link>
          </li>
        </ul>
        <div class="fl footer-ewm">
          <img src="../assets/img/ewm.png" alt="">
        </div>
      </div>
      <div class="footer-bot tc">
        <div class="bot-item"><a href="http://www.newhopegroup.com/" target="_blank">新希望集团</a></div>
        <div class="bot-item"><a href="http://www.newhopeagri.com/" target="_blank">新希望六和</a></div>
        <div class="bot-item"><a href="/">新希望乳业</a></div>
        <div class="bot-item"><a href="http://www.xinxiwangdichan.com/" target="_blank">新希望地产</a></div>
        <div class="bot-item"><a href="http://www.caogenzhiben.com/" target="_blank">草根知本</a></div>
        <!--<div class="bot-item"><a href="/">宝硕股份</a></div>-->
        <div class="bot-item"><a href="http://www.nhgfc.com/" target="_blank">财务公司</a></div>
      </div>
      <a class="go-mall border-box" href="https://xinxiwang.tmall.com/" target="_blank">
        <div class="l-mall"></div>
        <div class="flex r-mall">去商城逛逛 <img src="../assets/img/shop-icon2.png" alt=""></div>
      </a>
    </div>
    <p class="copy border-box">© 2002-{{nowYear}}（版权所有）新希望乳业股份有限公司
      &nbsp;&nbsp;&nbsp;<span class="copy1"><a href="http://www.beian.gov.cn/portal/index.do" target="_blank" style="text-decoration: underline !important;">公安备案51010402000309</a>
      &nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" style="text-decoration: underline !important;">蜀ICP备11008875号-1</a></span>
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      nowYear: (new Date()).getFullYear(),
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      navList: [
        {
          name: "首页",
          path: "/",
          children: []
        },
        {
          name: "关于新希望",
          path: "/about-group",
          children: [
            {
              name: "新希望集团",
              path: "/about-group"
            },
            {
              name: "新希望乳业",
              path: "/about-dairy"
            },
            {
              name: "布局·历程",
              path: "/about-layout"
            },
            {
              name: "企业荣誉",
              path: "/about-honor"
            },
            {
              name: "科研成果",
              path: "/about-science"
            },
            {
              name: "企业文化",
              path: "/about-culture"
            }
          ]
        },
        {
          name: "品牌活动",
          path: "/brand-choice",
          children: [
            {
              name: "新鲜一代的选择",
              path: "/brand-choice"
            },
            {
              name: "优质乳产业链",
              path: "/brand-industryChain"
            },
            {
              name: "新鲜盛典",
              path: "/brand-forum"
            },
            {
              name: "食育乐园",
              path: "/brand-paradise"
            },
            {
              name: "牛奶粉丝节",
              path: "/brand-fanFestival"
            }
          ]
        },
        {
          name: "鲜活产品",
          path: "/product-home",
          children: [
//            {
//              name: "新版初心",
//              path: "/product?tab=heart"
//            },
//            {
//              name: "特色单品",
//              path: "/product1?tab=single"
//            }
          ]
        },
        {
          name: "新鲜资讯",
          path: "/news?tab=0",
          children: [
            {
              name: "新鲜FANS",
              path: "/news?tab=0"
            },
            {
              name: "媒体窗口",
              path: "/news1?tab=1"
            },
            {
              name: "Hi，新乳业",
              path: "/news2?tab=2"
            }
          ]
        },
        {
          name: "投资者关系",
          path: "/investor?tab=3",
          children: [
            {
              name: "股票动态",
              path: "/investor?tab=3"
            },
            {
              name: "最新公告",
              path: "/investor0?tab=0"
            },
            {
              name: "定期报告",
              path: "/investor1?tab=1"
            },
            {
              name: "公司治理",
              path: "/investor2?tab=2"
            },
            {
              name: "投资者关系",
              path: "https://ir.p5w.net/c/002946.shtml",
              isOutlink: true
            }
          ]
        },
        {
          name: "可持续发展",
          path: "/develop-info",
          children: [
            {
              name: "可持续发展",
              path: "/develop-info"
            },
            {
              name: "希望有你",
              path: "/develop-withyou"
            },
//            {
//              name: "社会责任",
//              path: "/develop-respons"
//            },
//            {
//              name: "绿色环保",
//              path: "/develop-green"
//            }
          ]
        },
        {
          name: "科技创新",
          path: "/technical-innovation",
          children: [
            {
              name: "智慧牧场",
              path: "/technical-innovation"
            },
            {
              name: "数字工厂",
              path: "/technical-digital"
            },
            {
              name: "科技研发",
              path: "/technical-research"
            },
            {
              name: "营销数字化",
              path: "/technical-marketing"
            }
          ]
        },
        {
          name: "加入我们",
          path: "/join-us",
          children: [
            {
              name: "招聘",
              path: "/join-us"
            },
//            {
//              name: "HR信箱",
//              path: "/join-us/hr"
//            },
            {
              name: "联系我们",
              path: "/join-map"
            }
          ]
        }
      ]
    };
  },
  mounted() {
    var self = this;
    setTimeout(function(){
      self.navIndex = sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0;
      self.navIndex = self.$route.name;
    },200)
  },
  methods:{

    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index);
      this.menuName = name;

      window._czc.push(['_trackEvent', '尾部菜单', '点击菜单跳转页面']);
    },

  },
};
</script>
<style scoped>
  .footer{position:relative;padding: 5.8% 2.9% 3.68% 3.68%;background: #F9FCFC;border-top: 1px solid #E6E9E9;}
  .footer .footer-logo{width: 8.4%;height: 40px;margin-right:4%;}
  .footer .footer-logo img{width: 100%;height: auto;}
  .footer .footer-list{width: 9.7%;}
  .footer .item{width:100%;margin-top:16px;cursor: pointer;padding-right:4px;font: 12px/17px "msjh";color: rgba(68,68,68,.6);text-align: left;-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
  .footer .item:first-child{margin-top: 0;}
  .footer .item-head{color: rgba(68,68,68,1);}
  .footer .footer-ewm{width: 10%;height: 40px;}
  .footer .footer-ewm img{width: 100%;height: auto;}
  .footer .footer-bot{margin-top: 12.4%;text-align: center;}
  .footer .bot-item{display:inline-block;padding: 0 17px;font: 12px/17px "msjh";color: rgba(68,68,68,.6);border-right: 1px solid #D4D4D4;}
  .footer .bot-item:last-child{border-right: none;}
  .footer .item:hover,.footer .bot-item:hover{text-decoration: underline;}
  .footer .go-mall{position: absolute;right: 3.5%;bottom:34.6%;min-width:100px;height: 41px;padding-left:50px;padding-right:10px;border-radius: 6px;border: 1px solid #119BC6;overflow: hidden;cursor: pointer;}
  .footer .go-mall:hover{text-decoration: underline;color: #119BC6;}
  .footer .l-mall{position:absolute;top:-1px;left:-1px;bottom:-1px;width:43px;border-radius: 6px;background: #119BC6 url(../assets/img/shop-icon1.png) no-repeat center;background-size: 18px 18px;}
  .footer .r-mall{padding-left: 1vw;font: 12px/41px "msjh";color: #119BC6;}
  .footer .r-mall img{width: auto;height: 4px;margin-left: 4px;vertical-align: middle;}
  .copy {width: 80%;line-height: 25px;font-size: 12px;padding:15px 10px;color: #444;margin:0 auto;background: #fff;overflow: hidden;text-align: center;  }
  @media screen and (max-width: 768px) {
    .footer{display: none;}
    .copy1{ display: block; }
  }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue